import aemClientService from '@/services/aem/aemClientService';
import type {BadgeDetailsContentModel, DynamicPagesContentModel} from '@/types/content';
import type {GlobalButtonsContentModel} from '@/types/content/common';

/**
 * Root shape of the AEM-authored loyalty content.
 * Keep in sync with the AEM GraphQL query.
 */
export interface LoyaltyContent {
    globalButtons?: GlobalButtonsContentModel;
    dynamicPagesContent?: DynamicPagesContentModel;
    badgeDetailsContent?: BadgeDetailsContentModel;
}

let content: LoyaltyContent = {};

export const initContent = async (marketName: string, languageCode: string) => {
    content = (await aemClientService.initMarketContent(
        marketName?.toLowerCase(),
        languageCode?.toLowerCase()
    )) as LoyaltyContent;
};

export const getContent = (): LoyaltyContent => content;
